import React from "react";
import { tokens as t } from "./tokens";

export const fmtDate = (d) => {
  if (!d) return "-";
  const x = new Date(d);
  if (isNaN(x.getTime())) return "-";
  const p = (v) => String(v).padStart(2, "0");
  return `${x.getFullYear()}-${p(x.getMonth() + 1)}-${p(x.getDate())} ${p(x.getHours())}:${p(x.getMinutes())}`;
};

export const stripHtml = (s, max = 80) => {
  const txt = (s || "").replace(/<[^>]*>/g, " ").replace(/&[a-z]+;/gi, " ").replace(/\s+/g, " ").trim();
  return txt.length > max ? txt.slice(0, max) + "…" : txt;
};

export const RowAct = ({ icon: Icon, title, tone, onClick }) => (
  <button
    title={title}
    onClick={onClick}
    style={{ width: 32, height: 32, borderRadius: 8, display: "grid", placeItems: "center", border: "none", background: "none", cursor: "pointer", color: t.color.muted }}
    onMouseEnter={(e) => { e.currentTarget.style.background = tone === "del" ? t.color.redSoft : t.color.brandSoft; e.currentTarget.style.color = tone === "del" ? t.color.red : t.color.brandDark; }}
    onMouseLeave={(e) => { e.currentTarget.style.background = "none"; e.currentTarget.style.color = t.color.muted; }}
  >
    <Icon size={16} />
  </button>
);
